import { getDocumentText } from '../office';
/**
 * Host adapter for Microsoft Word
 */
export class WordAdapter {
    hostType = 'word';
    async getDocumentContext() {
        const content = await getDocumentText();
        return {
            content,
            metadata: {
                source: 'word-document',
            },
        };
    }
    getDeploymentType() {
        return 'AddinChat';
    }
}
